// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nxFIZnvZeZxWuJLQdomz,.DeuGNJ5vWvEdAByqrcwr{margin:4px 8px;margin-right:auto}.tSdjLio5dMJVfsFBLd9M{white-space:nowrap}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/teams/ui/ImportFromHubSpotDropdown/styles.module.scss"],"names":[],"mappings":"AAAA,4CAEE,cAAA,CACA,iBAAA,CAGF,sBACE,kBAAA","sourcesContent":[".importAllTeamsButton,\n.refreshDataButton {\n  margin: 4px 8px;\n  margin-right: auto;\n}\n\n.triggerButtonNowrap {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"importAllTeamsButton": `nxFIZnvZeZxWuJLQdomz`,
	"refreshDataButton": `DeuGNJ5vWvEdAByqrcwr`,
	"triggerButtonNowrap": `tSdjLio5dMJVfsFBLd9M`
};
export default ___CSS_LOADER_EXPORT___;
